module.exports = __webpack_public_path__ + "img/enterprise-figure-2.746bc2ac.png";